import React from 'react';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';

interface DashboardErrorBannerProps {
  message: string;
  onRetry: () => void;
}

export default function DashboardErrorBanner({ message, onRetry }: DashboardErrorBannerProps) {
  return (
    <Alert
      severity="error"
      action={
        <Button onClick={onRetry} color="inherit" size="small">
          Retry
        </Button>
      }
    >
      {message}. Check your connection and try again.
    </Alert>
  );
}
